import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {DatePipe} from "@angular/common";
import {ActivityType} from "../../model";

const ORDER_PROPERTY_PREFIX = 'order-activity';
const TALENT_PROPERTY_PREFIX = 'tracker-activity';
const ACTIVITY_MAPPINGS = {
  [ActivityType.SubmittedToClient]: 'submitted',
  [ActivityType.InterviewScheduled]: 'interview-scheduled-no-date',
  [ActivityType.RejectedByClient]: 'rejected-by-client',
  [ActivityType.AcceptedForOrder]: 'accepted-for-order',
  [ActivityType.ClientInterview]: 'interview-scheduled',
  [ActivityType.ClientInterviewComplete]: 'interview-complete',
  [ActivityType.SecondInterviewScheduled]: 'second-interview-scheduled',
  [ActivityType.SecondInterviewComplete]: 'second-interview-complete',
  [ActivityType.ThirdInterviewScheduled]: 'third-interview-scheduled',
  [ActivityType.ThirdInterviewComplete]: 'third-interview-complete',
  [ActivityType.InterviewRequested]: 'interview-requested',
  [ActivityType.OfferExtended]: 'offer-extended',
  [ActivityType.GatherNotInterested]: 'rejected-by-candidate',
  [ActivityType.ReviewedByClient]: 'reviewed',
  [ActivityType.ReconsideredByClient]: 'reconsidered',
  [ActivityType.InterviewCanceled]: 'interview-canceled'
};

export function isKnownActivity(typeId: number) {
  return ACTIVITY_MAPPINGS.hasOwnProperty(typeId);
}

@Pipe({name: 'trackerActivity'})
export class TrackerActivityPipe implements PipeTransform {

  constructor(private Translate: TranslateService,
              private Date: DatePipe) {
  }

  transform(activity: TrackerActivity, talentContext = false): string {
    if (activity && ACTIVITY_MAPPINGS.hasOwnProperty(activity.typeId)) {
      const prefix = talentContext ? TALENT_PROPERTY_PREFIX : ORDER_PROPERTY_PREFIX;
      return this.Translate.instant(`${prefix}.${ACTIVITY_MAPPINGS[activity.typeId]}`, {
        talentName: this.formatName(activity.talentFirstName, activity.talentLastName),
        talentFirst: activity.talentFirstName,
        createDate: this.formatDate(activity.createDate),
        activityDate: this.formatDate(activity.activityDate || activity.createDate)
      });
    }
    return '';
  }

  private formatName(firstName: string, lastName: string): string {
    if (!firstName) return '';
    return firstName + ' ' + (lastName ? lastName.substr(0, 1) : '');
  }

  private formatDate(date: Date): string {
    if (!date) return '';
    return this.Date.transform(date, 'MMMM dd, yyyy');
  }
}
